import { Dialog, DialogTitle, DialogActions, Button, Stack, Box, Typography, DialogContent } from "@mui/material";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { useTranslation } from "react-i18next";
type ConfirmDeleteModalProps = {
  onClose: () => void;
  onConfirmDelete: () => void;
  isDeletingComment: boolean;
};
export const ConfirmDeleteModal = ({
  onClose,
  onConfirmDelete,
  isDeletingComment
}: ConfirmDeleteModalProps) => {
  const {
    t
  } = useTranslation();
  return <Dialog open onClose={onClose} data-sentry-element="Dialog" data-sentry-component="ConfirmDeleteModal" data-sentry-source-file="ConfirmDeleteModal.tsx">
      <DialogTitle sx={{
      pb: 1
    }} data-sentry-element="DialogTitle" data-sentry-source-file="ConfirmDeleteModal.tsx">
        <Stack gap={1.5} data-sentry-element="Stack" data-sentry-source-file="ConfirmDeleteModal.tsx">
          <Box sx={{
          backgroundColor: "red.100",
          borderRadius: "100%",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }} data-sentry-element="Box" data-sentry-source-file="ConfirmDeleteModal.tsx">
            <DeleteRoundedIcon color="error" data-sentry-element="DeleteRoundedIcon" data-sentry-source-file="ConfirmDeleteModal.tsx" />
          </Box>
          <Typography variant="h5" display="inline" fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="ConfirmDeleteModal.tsx">
            {t("shell.deleteCommentTitle")}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ConfirmDeleteModal.tsx">
        <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="ConfirmDeleteModal.tsx">
          {t("shell.deleteCommentBody")}
        </Typography>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="ConfirmDeleteModal.tsx">
        <Button variant="text" color="inherit" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="ConfirmDeleteModal.tsx">
          {t("common.cancel")}
        </Button>
        <Button data-cy="ConfirmDeleteCommentButton" variant="contained" color="error" onClick={onConfirmDelete} loading={isDeletingComment} data-sentry-element="Button" data-sentry-source-file="ConfirmDeleteModal.tsx">
          {t("shell.deleteForever")}
        </Button>
      </DialogActions>
    </Dialog>;
};